// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D8BS","top":"styles_top__dxxCf","left":"styles_left__3RvBB","description":"styles_description__3jQQN"};